/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const menudishRouter = {
	path: '/menudish',
	component: Layout,
	redirect: 'noRedirect',
	name: '菜谱',
	id: 300000,
	meta: {
		title: '菜谱',
		icon: 'component',
		roles: [300000]
	},
	children: [
		{
			path: 'menudishs',
			component: () =>
				import(
					/* webpackChunkName: "menudishs" */ '@/leniuview/menudish/menudishTree'
				),
			name: '原料',
			id: 301000,
			meta: { title: '原料', roles: [301000] }
		},
		{
			path: 'menudishImport',
			component: () => import(/* webpackChunkName: "menudishImport" */ '@/leniuview/menudish/menudishImport'),
			name: '原料导入',
			id: 301000,
			hidden: true,
			meta: { title: '原料导入', roles: [301000] }
		},
		// {
		//   path: "nutriment",
		//   component: () => import("@/leniuview/menudish/nutriment"),
		//   name: "营养素信息",
		//   id: 302000,
		//   meta: { title: "menudish.yingyangsu", roles: [302000] }
		// },
		{
			path: 'type',
			// component: () => import('@/leniuview/menudish/dishs'),
			component: () =>
				import(
					/* webpackChunkName: "type" */ '@/leniuview/menudish/caipin/choose'
				),
			name: '菜品/套餐类型',
			meta: { title: '菜品/套餐类型', roles: [302000] }
		},
		{
			path: 'dishes',
			// component: () => import('@/leniuview/menudish/dishs'),
			component: () =>
				import(
					/* webpackChunkName: "dishes" */ '@/leniuview/menudish/caipin/index'
				),
			name: '菜品/套餐',
			id: 303000,
			meta: { title: '菜品/套餐', roles: [303000] }
		},
		{
			path: 'dishesImport',
			component: () => import(/* webpackChunkName: "dishesImport" */ '@/leniuview/menudish/caipin/dishesImport'),
			name: '批量菜品导入',
			id: 303000,
			hidden: true,
			meta: { title: '批量菜品导入', noCache: true, roles: [303000] }
		},
		// {
		//   path: "product",
		//   component: () =>
		//     import ( /* webpackChunkName: "product" */ "@/leniuview/menudish/product/index"),
		//   name: "商城",
		//   id: 304000,
		//   meta: { title: "商城", roles: [304000] }
		// },
		{
			path: 'caipu',
			component: () =>
				import(
					/* webpackChunkName: "caipu" */ '@/leniuview/menudish/caipu/index'
				),
			name: '菜谱',
			id: 306000,
			meta: { title: 'menudish.caipu', roles: [306000], noCache: true }
		},
		{
			path: 'fabu',
			component: () =>
				import(
					/* webpackChunkName: "fabu" */ '@/leniuview/menudish/caipu/fabu'
				),
			name: '新增菜谱',
			meta: { title: '新增菜谱', roles: [306000] },
			hidden: true
		},
		{
			path: 'detail',
			component: () =>
				import(
					/* webpackChunkName: "detail" */ '@/leniuview/menudish/caipu/detail'
				),
			name: '编辑菜谱',
			meta: { title: '编辑菜谱', roles: [306000] },
			hidden: true
		},
		{
			path: 'liuyangji',
			component: LayoutView,
			name: '留样机详情',
			id: 307000,
			meta: {
				title: 'menudish.liuyangji',
				roles: [307000]
			},
			redirect: 'liuyangji',
			children: [
				{
					path: 'macsacesamplerecord',
					component: () =>
						import('@/leniuview/menudish/liuyangji/macsacesamplerecord'),
					name: '留样记录',
					id: 307100,
					meta: {
						title: 'menudish.liuyangjilu',
						roles: [307100]
					}
				},
				{
					path: 'macsacesamplerecordcanteen',
					component: () =>
						import('@/leniuview/menudish/liuyangji/macsacesamplerecordcanteen'),
					name: '食堂未留样菜品',
					id: 307200,
					meta: {
						title: 'menudish.weiliuyang',
						roles: [307200]
					}
				}
			]
		}
		// {
		//   path: "dishesphoto",
		//   component: () => import("@/leniuview/menudish/dishesphoto"),
		//   name: "菜品识别照片",
		//   meta: { title: "菜品识别照片" }
		// },
		// {
		//   path: "dishesphotodetail",
		//   component: () => import("@/leniuview/menudish/dishesphotodetail"),
		//   name: "菜品识别照片详情",
		//   meta: { title: "菜品识别照片详情" },
		//   hidden: true
		// }
	]
}

export default menudishRouter
